// Iter 76 · Issue 4/10 · shared helper — the commercial Distintivo name is
// ALWAYS the primary title shown to users; the underlying norma (código/
// nombre) is secondary info, never the headline. Prevents the recurrent bug
// of showing "NOM-002-STPS-2010" where "Distintivo AIGIS Fire" belongs.

export function resolveDistintivoNames(desiredIds, distLookup) {
    const names = (desiredIds || [])
        .map((id) => distLookup?.[id]?.name || distLookup?.[id]?.code)
        .filter(Boolean);
    return names.length > 0 ? names.join(' + ') : null;
}

/**
 * @param {object} item - anything shaped like a request/cycle/finding with
 *   `desired_distintivo_ids` and/or `standard_code`/`standard_name`, and
 *   optionally a pre-resolved `distintivo_name` (server-side fallback for
 *   objects — like cycles — that don't carry desired_distintivo_ids).
 * @param {object} distLookup - { [distintivoId]: {name, code} }
 */
export function getDisplayTitle(item, distLookup) {
    const distName = resolveDistintivoNames(item?.desired_distintivo_ids, distLookup) || item?.distintivo_name || null;
    const stdCode = item?.standard_code || '';
    const stdName = item?.standard_name || '';
    return {
        // Iter 76 (corrección) · el título NUNCA cae al código de norma —
        // si no hay Distintivo resuelto, se usa el genérico "Distintivo".
        title: distName || 'Distintivo',
        subtitle: distName ? ([stdCode, stdName].filter(Boolean).join(' — ') || null) : (stdName || null),
    };
}
